import { render } from "./FavoritesSection.vue?vue&type=template&id=d6a55f4a&scoped=true"
import script from "./FavoritesSection.vue?vue&type=script&lang=js"
export * from "./FavoritesSection.vue?vue&type=script&lang=js"

import "./FavoritesSection.vue?vue&type=style&index=0&id=d6a55f4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6a55f4a"]])

export default __exports__